import React from 'react';
import { Brain, Lightbulb, Target, Compass, CheckCircle } from 'lucide-react';
import ServicePage from './ServicePage';

const consultingServicesData = {
  title: "IT Consulting Services",
  description: "Strategic technology consulting to drive your business forward. Our expert consultants help you make informed decisions and achieve your IT objectives.",
  features: [
    {
      icon: Brain,
      title: "Strategic Planning",
      description: "Long-term technology strategy",
      details: [
        "IT roadmap development",
        "Digital transformation",
        "Technology assessment",
        "Innovation planning"
      ]
    },
    {
      icon: Target,
      title: "Business Analysis",
      description: "Comprehensive IT analysis",
      details: [
        "Process optimization",
        "Requirements gathering",
        "Gap analysis",
        "Solution architecture"
      ]
    },
    {
      icon: Compass,
      title: "Technology Advisory",
      description: "Expert guidance and support",
      details: [
        "Technology selection",
        "Vendor management",
        "Risk assessment",
        "Compliance consulting"
      ]
    }
  ],
  stats: [
    {
      icon: Brain,
      value: "20+",
      label: "Years Experience"
    },
    {
      icon: Target,
      value: "300+",
      label: "Clients Advised"
    },
    {
      icon: Lightbulb,
      value: "95%",
      label: "Success Rate"
    },
    {
      icon: Compass,
      value: "100%",
      label: "Client Retention"
    }
  ],
  process: [
    {
      number: 1,
      title: "Assessment",
      description: "Current state analysis"
    },
    {
      number: 2,
      title: "Strategy",
      description: "Solution development"
    },
    {
      number: 3,
      title: "Planning",
      description: "Implementation roadmap"
    },
    {
      number: 4,
      title: "Guidance",
      description: "Ongoing advisory support"
    }
  ],
  pricing: [
    {
      title: "Advisory",
      price: "$250/hr",
      description: "Expert consultation",
      features: [
        "Technology Assessment",
        "Strategic Planning",
        "Solution Architecture",
        "Best Practices"
      ]
    },
    {
      title: "Comprehensive",
      price: "From $5,000/mo",
      description: "Ongoing strategic support",
      features: [
        "Everything in Advisory",
        "Regular Strategy Sessions",
        "Project Oversight",
        "Monthly Reporting",
        "Priority Access"
      ],
      recommended: true
    },
    {
      title: "Enterprise",
      price: "Custom",
      description: "Full strategic partnership",
      features: [
        "Everything in Comprehensive",
        "Dedicated Consultant",
        "Executive Advisory",
        "Quarterly Reviews",
        "Custom Solutions"
      ]
    }
  ],
  testimonials: [
    {
      quote: "UCX's consulting services helped us develop a clear technology roadmap that aligned perfectly with our business goals.",
      author: "Emily Watson",
      role: "CEO",
      company: "Innovation Corp"
    },
    {
      quote: "Their strategic guidance was instrumental in our digital transformation journey.",
      author: "Daniel Kim",
      role: "CTO",
      company: "Digital Solutions"
    },
    {
      quote: "The depth of knowledge and practical advice provided by their consultants is exceptional.",
      author: "Sarah Martinez",
      role: "Operations Director",
      company: "Global Tech"
    }
  ]
};

export default function ConsultingServices() {
  return <ServicePage {...consultingServicesData} />;
}